import React from 'react';
import { RequestState } from 'shared/auth/hooks/useRequestState';
import { FeedbackStatus } from 'donor/portal/pages/FeedbackDashboard/api';
import TrueImpactButton, {
  TrueImpactButtonWithLoading,
} from 'shared/design-system/components/TrueImpactButton';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

const styleGreen = { color: COLORS.success };
const checkIcon = <FontAwesomeIcon icon={faCircleCheck} style={styleGreen} />;
const getButtonText = (
  status: FeedbackStatus,
  isCompleted?: boolean,
): React.ReactNode => {
  switch (status) {
    case 'Awaiting TI Verification':
    case 'Awaiting Funder Verification':
      if (isCompleted) {
        return <div style={styleGreen}>{checkIcon} Verified</div>;
      }
      return 'Accept Response';

    default:
      if (isCompleted) {
        return <div style={styleGreen}>{checkIcon} Resolved</div>;
      }
      return 'It‘s Correct As Is';
  }
};

const StyledDiv = styled.div`
  display: flex;
  .full-button,
  .left-button,
  .right-button {
    flex: 1;
    button {
      width: 100%;
    }
  }
  .left-button {
    margin-right: 10px;
  }
  .right-button {
    margin-left: 10px;
  }
`;

export interface FeedbackVerificationButtonsProps {
  allowEdits: boolean;
  isCompleted?: boolean;
  isEditLoading?: boolean;
  className?: string;
  feedbackStatus: FeedbackStatus;
  requestState: RequestState<unknown>;
  handleEditClick: () => unknown;
  handleVerifiedClick: () => unknown;
}

const FeedbackVerificationButtons: React.FC<FeedbackVerificationButtonsProps> = ({
  allowEdits,
  feedbackStatus,
  requestState,
  isEditLoading,
  isCompleted,
  className,
  handleEditClick,
  handleVerifiedClick,
}) => {
  return (
    <StyledDiv className={className}>
      {allowEdits && (
        <TrueImpactButton
          isLoading={isEditLoading}
          variant="secondary-large"
          onClick={handleEditClick}
          className="left-button"
        >
          Make Edits
        </TrueImpactButton>
      )}
      <TrueImpactButtonWithLoading
        variant="secondary-large"
        onClick={isCompleted ? undefined : handleVerifiedClick}
        isLoading={requestState.type === 'REQUEST_START'}
        className={allowEdits ? 'right-button' : 'full-button'}
      >
        {getButtonText(feedbackStatus, isCompleted)}
      </TrueImpactButtonWithLoading>
    </StyledDiv>
  );
};

export default FeedbackVerificationButtons;
